module.exports = __webpack_public_path__ + "static/media/sign.9defc689.png";